import { getUrlParamZone } from "../../utils/urlParams";
import { Menu } from "../menus/Menu";
import { isDevice } from "../../utils/isDevice";
export class InstrucctionsModal {
  constructor() {
    if (InstrucctionsModal.instance) {
      return InstrucctionsModal.instance;
    }
    InstrucctionsModal.instance = this;
    this.menu = new Menu();
    this.modal = document.querySelector("#instrucctions");
    this.modalMobil = document.querySelector("#instrucctionsMobil");

    this.btnInstructions = document.querySelector("#btn-ok-instrucctions");
    this.btnInstructionsMobil = document.querySelector(
      "#btn-ok-instrucctionsMobil"
    );
    this.initListeners();
    if (isDevice()) {
      this.modal.style.display = "none";
    } else {
      this.modalMobil.style.display = "none";
    }
  }

  hiddenModalInstructions() {
    this.modal.classList.add("hidden");
  }

  hiddenModalInstructionsMobil() {
    this.modalMobil.classList.add("hidden");
  }

  initListeners() {
    this.btnInstructions.addEventListener("click", () => {
      this.hiddenModalInstructions();
      if (!getUrlParamZone()) {
        this.menu.moveToGeneralView(1.5);
      }
    });

    this.btnInstructionsMobil.addEventListener("click", () => {
      this.hiddenModalInstructionsMobil();
      if (!getUrlParamZone()) {
        this.menu.moveToGeneralView(1.5);
      }
    });
  }
}
